// @ts-nocheck
import {
    CartLineModel,
    OrderLineModel,
    ProductModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";

export type HasSampleModelParameter = ProductModel | CartLineModel | WishListLineModel | OrderLineModel;

const getHasSample = (model: HasSampleModelParameter | undefined) => {
    return Boolean(model?.properties.sampleItemNumber);
};

export default getHasSample;
